import { render, staticRenderFns } from "./ProjectDocument.vue?vue&type=template&id=470da361&"
import script from "./ProjectDocument.vue?vue&type=script&lang=js&"
export * from "./ProjectDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports